import { render, staticRenderFns } from "./SelectedVenue.vue?vue&type=template&id=cf2c8ebe&scoped=true"
import script from "./SelectedVenue.vue?vue&type=script&lang=ts"
export * from "./SelectedVenue.vue?vue&type=script&lang=ts"
import style0 from "./SelectedVenue.vue?vue&type=style&index=0&id=cf2c8ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2c8ebe",
  null
  
)

export default component.exports